import BopisKohlsItem from 'components/SharedComponents/BopisKohlsItem/BopisKohlsItem';
import { withBopisKohlsItemProps } from 'viewModel/sharedComponents/bopisKohlsItem/withBopisKohlsItemProps';

const WrappedBopisKohlsItem = withBopisKohlsItemProps(BopisKohlsItem);

export default WrappedBopisKohlsItem;
